import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';

const TextAreaComponent = ({ title, text, setText, placeholder = "Voer tekst in...", onSave }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [currentText, setCurrentText] = useState(text ?? '');

    const handleEditClick = () => {
        setIsEditing(true);
        setCurrentText(text ?? '');
    };

    const handleBlur = () => {
        setIsEditing(false);
        setText(currentText);
        
        // Call onSave callback if provided
        if (onSave) {
            onSave(currentText);
        }
    };

    const handleKeyDown = (e) => {
        // Save on Ctrl+Enter or Escape to cancel
        if (e.key === 'Escape') {
            setCurrentText(text ?? '');
            setIsEditing(false);
        }
        if (e.key === 'Enter' && e.ctrlKey) {
            handleBlur();
        }
    };

    return (
        <div className="whiteBox email-main-container p-4">
            <div className="email-header d-flex justify-content-between align-items-center mb-3">
                <div className="BlockTitle">{title}</div>
                <FontAwesomeIcon 
                    icon={faPencilAlt} 
                    className="text-muted cursor-pointer hover:text-primary"
                    onClick={handleEditClick}
                    style={{ cursor: 'pointer' }}
                />
            </div>
            <div>
                {isEditing ? (
                    <textarea
                        className="form-control rounded-4"
                        rows="4"
                        placeholder={placeholder}
                        value={currentText}
                        onChange={(e) => setCurrentText(e.target.value)}
                        onBlur={handleBlur}
                        onKeyDown={handleKeyDown}
                        autoFocus
                    />
                ) : (
                    <div 
                        className="p-3 border rounded-4 bg-light min-h-24 cursor-pointer"
                        style={{ 
                            minHeight: '100px', 
                            whiteSpace: 'pre-wrap' 
                        }}
                    >
                        {text || <span className="text-muted">{placeholder}</span>}
                    </div>
                )}
            </div>
            {isEditing && (
                <small className="text-muted mt-1 d-block">
                    Druk op Ctrl+Enter om op te slaan, Escape om te annuleren
                </small>
            )}
        </div>
    );
};

export default TextAreaComponent;